import { render, staticRenderFns } from "./Work.vue?vue&type=template&id=3d0863e4&scoped=true"
import script from "./Work.vue?vue&type=script&lang=js"
export * from "./Work.vue?vue&type=script&lang=js"
import style0 from "./Work.vue?vue&type=style&index=0&id=3d0863e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0863e4",
  null
  
)

export default component.exports